import { __ } from '@wordpress/i18n';
import Card from '../card';
import Paginate from '../paginate';
import { useSearchParams } from 'react-router-dom';
import './styles.scss';

const ArchiveList = ({
    isLoading,
    hoverHandler,
    perPage,
    totalHits,
    posts,
    type,
    categories,
    getImages,
    getFactsText,
    getAltFacts
}) => {

    let [searchParams] = useSearchParams();
    const page = searchParams.get('page') ? searchParams.get('page') : 1;
    const currentType = searchParams.get('typ') ? searchParams.get('typ') : null;

    const getTypeOfListText = () => {
       if (type === 'experience') {
            if (categories && currentType) {
                const currentCategory = categories.find(f => f.id.toString() === currentType.toString());

                if (currentCategory) {
                    return currentCategory.name.toLocaleLowerCase();
                }
            }
        }

        const title = document.title.replace('– Dalslandkanal', '');
        return title ? title.toLocaleLowerCase() : '';
    };

    return (
        <div className="archive-list">
            <div className="archive-list__list">
                {posts && posts.map(post => {
                    return (
                        <Card key={post.id} id={post.id} hoverHandler={hoverHandler} useMediumImages={true} url={post.link} title={post.title.rendered} images={getImages(post)} facts={getFactsText(post)} altFacts={getAltFacts(post)} />
                    );
                })}
            </div>
            <Paginate useLink={true} location={window.location} queryPage={page} totalCount={totalHits} perPage={perPage} typeOfList={getTypeOfListText()} />
        </div>
    );
};

export default ArchiveList;